import React from "react";
import { BrowserRouter, Routes, Route, Navigate, RouteProps } from "react-router-dom";
import {
    /* PLOP_ROUTE_IMPORT */
    BancoDeTalentos,
    Favoritos,
    HubPosGraduacao,
    SejaPlus,
    Contratos,
    CommentDetail,
    ResetPassword,
    MultimediaDetails,
    PublicProfile,
    Redirection,
    ArticleDetail,
    Downloads,
    Ebooks,
    Articles,
    Multimidias,
    Courses,
    Home,
    CourseDetail,
    Login,
    Comunity,
    ComunityDetail,
    StudentProfile,
    NotificationList,
    SearchResultsPage,
} from "./pages";
import { Loading, ExternalLink } from "./components/elements";
import { useUserContext } from "./context/user/AuthContext";
// import { isAuthenticated } from "./services/auth";

interface ICustomRouteProps {
    isPublic?: boolean;
    isPlus?: boolean;
    path: string | string[];
    element: React.ReactElement;
}

const CustomRoute = ({ isPublic, isPlus, path, element }: ICustomRouteProps) => {
    const { loading, authenticated, userData } = useUserContext();

    if (isPlus && authenticated) {
        // tratar o redirect pro caso do usuário clicar num link para uma área que ele não tem permissão
        const userGroups = userData.grupos.split(",");
        if (
            userGroups.includes("Alunos") ||
            userGroups.includes("NMAAlunos") ||
            userGroups.includes("Mentores") ||
            userGroups.includes("Tutor") ||
            userGroups.includes("CIA30Dias") ||
            userGroups.includes("CIA_plus_empresa") ||
            userGroups.includes("cia_maais_pro_gestor") ||
            userGroups.includes("cia_maais_pro_colab") ||
            userGroups.includes("CIA_plus_anual") ||
            userGroups.includes("NMA30dias")
        ) {
            return element;
        } else {
            return <Navigate to="/cursos" replace />;
        }
    }
    if (loading) {
        return <Loading />;
    }

    if (isPlus && authenticated) {
        // tratar o redirect pro caso do usuário clicar num link para uma área que ele não tem permissão
        const userGroups = userData.grupos.split(",");
        if (
            userGroups.includes("Alunos") ||
            userGroups.includes("NMAAlunos") ||
            userGroups.includes("Mentores") ||
            userGroups.includes("Tutor") ||
            userGroups.includes("CIA30Dias") ||
            userGroups.includes("CIA_plus_empresa") ||
            userGroups.includes("CIA_plus_longo") ||
            userGroups.includes("CIA_plus_anual") ||
            userGroups.includes("NMA30dias")
        ) {
            return element;
        } else {
            return <Navigate to="/cursos" replace />;
        }
    }

    if (!isPublic && !authenticated) {
        if (window.location.pathname !== "/") {
            localStorage.setItem("redirectUrl", window.location.pathname);
        }
        return <Navigate to="/" replace />;
    }

    return element;
};

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<CustomRoute isPublic path="/" element={<Login />} />} />
                <Route path="/esqueci-senha" element={<CustomRoute isPublic path="/esqueci-senha" element={<ResetPassword />} />} />
                {/* PLOP_INJECT_ROUTE */}
                <Route path="/banco-de-talentos" element={<CustomRoute path="/banco-de-talentos" element={<BancoDeTalentos />} />} />
                <Route path="/Favoritos" element={<CustomRoute path="/Favoritos" element={<Favoritos />} />} />
                <Route path="/pos-graduacao" element={<CustomRoute path="/pos-graduacao" element={<HubPosGraduacao />} />} />
                <Route path="/seja-plus" element={<CustomRoute path="/seja-plus" element={<SejaPlus />} />} />
                <Route path="/contratos/:id" element={<CustomRoute path="/contratos/:id" element={<Contratos />} />} />
                <Route path="/perfil/:id" element={<CustomRoute path="/perfil/:id" element={<PublicProfile />} />} />
                <Route path="/redirection" element={<CustomRoute path="/redirection" element={<Redirection />} />} />
                <Route path="/notificacoes" element={<CustomRoute path="/notificacoes" element={<NotificationList />} />} />
                <Route path="/meu-perfil" element={<CustomRoute path="/meu-perfil" element={<StudentProfile />} />} />
                <Route path="/cursos" element={<CustomRoute path="/cursos" element={<Courses />} />} />
                <Route path="/cursos/:slug" element={<CustomRoute path="/cursos/:slug" element={<CourseDetail />} />} />
                <Route path="/cursos/:slug/:aulaid" element={<CustomRoute path="/cursos/:slug/:aulaid" element={<CourseDetail />} />} />
                <Route
                    path="/cursos/:slug/:aulaid/:commentid"
                    element={<CustomRoute path="/cursos/:slug/:aulaid/:commentid" element={<CourseDetail />} />}
                />
                <Route
                    path="/detalhe-comentario/:debateId/:commentId"
                    element={<CustomRoute path="/detalhe-comentario/:debateId/:commentId" element={<CommentDetail />} />}
                />
                <Route path="/dashboard" element={<CustomRoute isPlus path="/dashboard" element={<Home />} />} />
                <Route path="/materiais" element={<CustomRoute isPlus path="/materiais" element={<Downloads />} />} />
                <Route
                    path="/materiais/categoria/:category"
                    element={<CustomRoute isPlus path="/materiais/categoria/:category" element={<Downloads />} />}
                />
                <Route path="/ebooks" element={<CustomRoute path="/ebooks" element={<Ebooks />} />} />
                <Route
                    path="/ebooks/categoria/:category"
                    element={<CustomRoute path="/ebooks/categoria/:category" element={<Ebooks />} />}
                />
                <Route path="/artigos" element={<CustomRoute isPlus path="/artigos" element={<Articles />} />} />
                <Route
                    path="/artigos/categoria/:category"
                    element={<CustomRoute isPlus path="/artigos/categoria/:category" element={<Articles />} />}
                />
                <Route path="/artigo/:slug" element={<CustomRoute isPlus path="/artigo/:slug" element={<ArticleDetail />} />} />
                <Route path="/multimidias" element={<CustomRoute isPlus path="/multimidias" element={<Multimidias />} />} />
                <Route path="/serie/:slug" element={<CustomRoute isPlus path="/serie/:slug" element={<MultimediaDetails />} />} />
                <Route path="/serie/:slug/:id" element={<CustomRoute isPlus path="/serie/:slug/:id" element={<MultimediaDetails />} />} />
                <Route path="/noticias" element={<CustomRoute isPlus path="/noticias" element={<Comunity />} />} />
                <Route path="/noticias/categoria/:slug" element={<CustomRoute isPlus path="/noticias/categoria/:slug" element={<Comunity />} />} />
                <Route path="/noticias/:comunityId" element={<CustomRoute isPlus path="/noticias/:comunityId" element={<ComunityDetail />} />} />
                <Route path="/buscar" element={<CustomRoute path="/buscar" element={<SearchResultsPage />} />} />
                <Route
                    path="/sociautism"
                    element={<CustomRoute path="/sociautism" element={<ExternalLink url="https://sociautism.ciaautismo.com.br/" />} />}
                />
                <Route
                    path="/indicacao"
                    element={
                        <CustomRoute
                            path="/indicacao"
                            element={
                                <ExternalLink url="http://cursoaba.academiadoautismo.com.br/indicacao/?bl_ref=DW306" redirectTo="/redirection" />
                            }
                        />
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}
